const mapboxgl = require("mapbox-gl");
const segmentInsert = require("@mapbox/segmentio-insert");

mapboxgl.accessToken = "pk.eyJ1IjoibWJ4c29sdXRpb25zIiwiYSI6ImNrNmI0N2E3MzAwMmcza213Z3BqeDd2d2IifQ.P01BvPYYWBkDPdHeHmplqw";
const analytics = segmentInsert("fl0c8p240n");
analytics.track("Demo Viewed", { name: "map_compare" });

let center = [139.768899, 35.680298];
let zoom = 11;

const mapboxmap = new mapboxgl.Map({
  container: "mapboxmap", // container id
  style: "mapbox://styles/mbxsolutions/ckhmmqxdh012c19qc970odr5w?optimize=true", // stylesheet location
  center: center, // starting position [lng, lat]
  zoom: zoom
});

// Eslint disabled due to javascript coming in in the HTML file.
const googlemap = new google.maps.Map(document.getElementById("googlemap"), { // eslint-disable-line no-undef
  center: { lat: center[1], lng: center[0] },
  zoom: zoom + 1,
  zoomControl: true,
  mapTypeControl: false,
  streetViewControl: false,
  rotateControl: true,
  fullscreenControl: false
});

mapboxmap.addControl(new mapboxgl.NavigationControl(), "bottom-right");
mapboxmap.scrollZoom.disable();

let googleMoved = false;
let mapboxMoved = false;

const mapboxSync = function() {
  if (!googleMoved) {
    mapboxMoved = true;
    center = mapboxmap.getCenter().toArray();
    zoom = Math.round(mapboxmap.getZoom() + 1);
    googlemap.setCenter({ lat: center[1], lng: center[0] });
    googlemap.setZoom(zoom);
    mapboxMoved = false;
  }
};

const googleSync = function() {
  if (!mapboxMoved) {
    googleMoved = true;
    zoom = Math.round(googlemap.getZoom() - 1);
    center = googlemap.getCenter().toJSON();
    center = [center.lng, center.lat];
    console.log(center);
    mapboxmap.setZoom(zoom);
    mapboxmap.setCenter(center);
    googleMoved = false;
  }
};
mapboxmap.on("load", () => {
  mapboxmap.on("moveend", mapboxSync);
  googlemap.addListener("idle", googleSync);

  mapboxmap.addLayer({
    "id": "3d-buildings",
    "source": "composite",
    "source-layer": "building",
    "filter": ["==", "extrude", "true"],
    "type": "fill-extrusion",
    "minzoom": 15,
    "paint": {
      "fill-extrusion-color": "#D3D3D3",
      "fill-extrusion-height": {
        "type": "identity",
        "property": "height"
      },
      "fill-extrusion-base": {
        "type": "identity",
        "property": "min_height"
      },
      "fill-extrusion-opacity": .5
    }
  }, "waterway-label");
});
